import React from 'react';
import ActionMenu from './ActionMenu';

function SectionMenu({ title, onRename, onDelete }) {
  return (
    <ActionMenu
      label={`Options for ${title}`}
      items={[
        { label: 'Rename', onSelect: onRename },
        { label: 'Delete', onSelect: onDelete, danger: true }
      ]}
    />
  );
}

export default SectionMenu;